<template>
  <div id="player" :class="[customClass]">
    <template v-if="staff">
      <div class="name">
        {{ item.name }} <b>{{ item.surname }}</b>
        <div class="position">
          {{ $t(item.cargo) }}
        </div>
      </div>
    </template>
    <template v-else>
      <div class="number" v-if="item.number">{{ item.number }}</div>
      <div class="name">
        {{ item.name }} <b>{{ item.surname }}</b>
        <div class="position">{{ $t(item.position) }}</div>
      </div>
    </template>
  </div>
</template>

<script>
import { Api } from "@/core/api.js";

const api = new Api();

export default {
  name: "Player",
  props: {
    item: Object,
    staff: Boolean,
    customClass: String
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
#player {
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 3px;
  font-size: 12px;
  padding: 8px;
  width: 100%;
  height: 55px;
  border-left: 5px solid $main-color;
  display: flex;
  align-items: center;
  //   display: flex;
  //   align-items: center;

  .number {
    width: 25px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    background: $main-color;
    color: #fff;
    border-radius: 100%;
    display: inline-block;
  }
  .name {
    display: inline-block;
    width: calc(100% - 25px);
    color: #222;
    padding-left: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;

    b {
      font-family: $font-title;
    }
  }
  .position {
    width: 100%;
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #666;
  }

  &.staff {
  }

  &.right {
    border-right: 5px solid #ff5722;
    border-left: none;
    flex-direction: row-reverse;

    .name {
      padding-left: 0;
      padding-right: 10px;
    }
    .number {
      background-color: #ff5722;
    }
  }
}
</style>
